import DollarTagIcon from '../../../../../icons/dollar-tag.svg?react';
import HandSelectClickIcon from '../../../../../icons/hand-select-click.svg?react';
import UserIcon from '../../../../../icons/user.svg?react';
import DocumentIcon from '../../../../../icons/document.svg?react';

export default function PurchasingProcessData() {
  return {
    title: "The Purchasing Process: a modern approach",
    subtitle: "",
    image: "/product-landing/term/circle1.png",
    steps: [
      {
          title: "Determine Coverage Amount",
          icon: DollarTagIcon,
          paragraphs: [
            "",
        ]
      },
      {
          title: "Personalize Quote",
          icon: HandSelectClickIcon,
          paragraphs: [
            "",
        ]
      },
      {
          title: "Select and Apply",
          icon: UserIcon,
          paragraphs: [
            "",
        ]
      },
      {
          title: "Approval and Payment",
          icon: DocumentIcon,
          paragraphs: [
            "",
        ]
      }
    ]
  }
}